import {type ProjectTemplate} from '../initProject'

const cleanTemplate: ProjectTemplate = {}

export default cleanTemplate
